import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ShiftService {
  private apiUrl = environment.baseUrl + '/wfm/shift';

  constructor(private http: HttpClient) {}

  getShiftList(search: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/list`, { search });
  }

  getShiftById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/get/${id}`);
  }

  addShift(shiftData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/add`, shiftData);
  }

  updateShift(shiftData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/update`, shiftData);
  }

  deleteShift(id: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/delete/${id}`, {});
  }
}
